import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFloppyDisk1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFloppyDisk1"><Path d="M17 3H17.5607L21 6.43934V21H17V12H7V21H3V3H7V9H17V3Z" fill="currentColor"/><Path d="M15.5 3H8.5V7.5H15.5V3Z" fill="currentColor"/><Path d="M8.5 21H15.5V13.5H8.5V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFloppyDisk1;
